// extracted by mini-css-extract-plugin
export default {"root":"Section_root__JajC7","header":"Section_header__pCM7C"};